import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { INewInstallation } from '../../../../types/installation'
import { createInstallation } from '../../../../store/installations/actions'
import { Create } from './Create'
import { ICreateStateProps, ICreateDispatchProps } from './types'
import { IState } from '../../../../store/types'
import { isLoading } from 'flux-entities'

const mapStateToProps = (state: IState): ICreateStateProps => {
  return {
    installationsLoading: isLoading(state.installations)
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): ICreateDispatchProps => {
  return {
    createInstallation: (installation: INewInstallation) => {
      return dispatch(createInstallation(installation))
    }
  }
}

const CreateContainer = connect(mapStateToProps, mapDispatchToProps)(Create)

export {
  CreateContainer
}
